<script lang="ts" setup>
import type { FeedbackType } from "~~/models/forms";

defineProps<{ msg: string; type: FeedbackType }>();

const { t } = useI18n();
</script>

<template>
  <div>
    <UAlert
      v-if="msg.length > 0 && type === 'info'" variant="subtle" icon="i-ph-chat-circle"
      :ui="{ root: 'rounded-lg bg-transparent border border-blue text-blue' }"
    >
      <template #description>
        <!-- eslint-disable-next-line vue/no-lone-template -->
        <div class="text-blue font-semibold" v-html="msg" />
      </template>
    </UAlert>

    <UAlert
      v-if="msg.length > 0 && type === 'success'" variant="subtle" icon="i-ph-check"
      :ui="{ root: 'rounded-lg bg-transparent border border-success text-success' }"
    >
      <template #description>
        <!-- eslint-disable-next-line vue/no-lone-template -->
        <div class="text-success font-semibold" v-html="msg" />
      </template>
    </UAlert>

    <UAlert
      v-if="msg.length > 0 && type === 'warning'" variant="subtle" icon="i-ph-info"
      :ui="{ root: 'rounded-lg bg-transparent border border-warning text-warning' }"
    >
      <template #description>
        <!-- eslint-disable-next-line vue/no-lone-template -->
        <div class="text-warning font-semibold" v-html="msg" />
      </template>
    </UAlert>

    <UAlert
      v-if="msg.length > 0 && type === 'fail'" variant="subtle" icon="i-ph-warning"
      :title="t('common.title.error')"
      :ui="{ root: 'rounded-lg bg-transparent border border-danger text-danger' }"
    >
      <template #description>
        <!-- eslint-disable-next-line vue/no-lone-template -->
        <div class="text-danger font-semibold" v-html="msg" />
      </template>
    </UAlert>
  </div>
</template>

<style scoped>

</style>
